import { render, staticRenderFns } from "./MyProjectInvoiceConfirms.vue?vue&type=template&id=6d4c4db8&scoped=true"
import script from "./MyProjectInvoiceConfirms.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyProjectInvoiceConfirms.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MyProjectInvoiceConfirms.vue?vue&type=style&index=0&id=6d4c4db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4c4db8",
  null
  
)

export default component.exports